<div class="traffic-logs-vs-dropdown">
    <avi-dropdown
        name="vs-selector"
        [options]="vsOptions"
        [disabled]="vsOptions.length === 1"
        [ngModel]="vsId"
        (ngModelChange)="handleVsChange($event)"
        required
    ></avi-dropdown>
</div>
